import { ActionCreator } from "redux";
import {
    SatisfactoryLevel,
    TypeOfFinalTransaction,
    ErrorCodes} from "../../dtos/KioskDtos.dtos";
import {
  GET_CLINIC_INFORMATION_REQUEST,
  POST_LOGIN_INFORMATION,
  POST_SURVEY_RESULT
} from "./constant";
import {
  PostSurveyResultToServerAction,
  GetClinicInformationRequestAction,
  PostLoginInformationToServerAction
} from "./types";

export const getClinicInformationRequest: ActionCreator<GetClinicInformationRequestAction> = () => ({
    type: GET_CLINIC_INFORMATION_REQUEST
});

export const postLoginInformationToServer: ActionCreator<PostLoginInformationToServerAction> = (userName: string, password: string, authenticationCode: string) => ({
    type: POST_LOGIN_INFORMATION,
    payload: {
        userName,
        password,
        authenticationCode
    }
});

export const postSurveyResultToServer : ActionCreator<PostSurveyResultToServerAction> = (
    satisfactoryLevel: SatisfactoryLevel,
    typeOfFinalTransaction: TypeOfFinalTransaction,
    errorCode: ErrorCodes = ErrorCodes.None
) => ({
    type: POST_SURVEY_RESULT,
    payload: {
        satisfactoryLevel,
        typeOfFinalTransaction,
        errorCode
    }
});



// WEBPACK FOOTER //
// ./src/sagas/RequestSagas/actions.ts